// extracted by mini-css-extract-plugin
export default {"external":"akQtcu","plate":"bkQtcu"};